
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class ItemsRegisterFiltersDialog extends Serenity.PropertyDialog<any, any>
    {

        public form = new ItemsRegisterFiltersForm(this.idPrefix);
        public entityId: number;
        public vouchernos: string[];
        public partyids: number[];
        public vouchertypeid: number;
        public inst;
        public checksuccess: boolean;
        public filterformfor: string;//To check if Filters for Production/Transactions
        //public ItemsOnly: boolean;//for Items Register
        constructor() {
            super();

            this.form = new ItemsRegisterFiltersForm(this.idPrefix);
            this.form.Parties.changeSelect2(e => {
                if (this.form.Parties.value != null && this.form.Parties.value != "") {
                    var x = this.form.Parties.selectedItem;
                    var vouchers = this.form.VoucherNo.items;
                    var _vouchers = [];
                    vouchers = vouchers.filter(x => x.source.PartyId == this.form.Parties.selectedItem.PartyId);
                    for (var i = 0; i < vouchers.length; i++) {
                        var newitem: Serenity.Select2Item = {
                            id: vouchers[i].id,
                            text: vouchers[i].text,
                            source: vouchers[i]
                        }
                        _vouchers.push(newitem);
                    }

                    this.form.VoucherNo.setSelect2Items(_vouchers);
                }
            });
            this.form.VoucherTypeId.changeSelect2(e => {
                let items;
                var vouchertypeid = parseInt(this.form.VoucherTypeId.value);
                var itemsonly = this.form.ItemsOnly.value;
                if (itemsonly) {
                    Reports.ItemsRegisterService.GetVouchers({ VoucherTypeId: vouchertypeid }, response => {
                        items = response.Vouchers;
                        var _parties = [];
                        var parties = response.Parties;
                        for (var i = 0; i < parties.length; i++) {
                            var party = parties[i];

                            if (party.POSCustomerId > 0) {
                                if (party.CustomerName != null) {
                                    var newparty: Serenity.Select2Item = {
                                        id: party.POSCustomerId.toString(),
                                        text: party.CustomerName,
                                        source: party
                                    }
                                    _parties.push(newparty);
                                }
                            }
                            else if (party.PartyId > 0) {
                                if (party.LedgerName != null) {
                                    var newparty: Serenity.Select2Item = {
                                        id: party.PartyId.toString(),
                                        text: party.LedgerName,
                                        source: party
                                    }
                                    _parties.push(newparty);
                                }
                            }
                        }

                        this.form.Parties.setSelect2Items(_parties);


                    }, { async: false });
                } else {
                    Reports.ShortListService.GetVouchers({ VoucherTypeId: vouchertypeid }, response => {
                        items = response.Entities


                    }, { async: false });

                }
                var _items = [];
                for (var i = 0; i < items.length; i++) {
                    var newitem: Serenity.Select2Item = {
                        id: items[i].TransId,
                        text: items[i].VoucherNo,
                        source: items[i]
                    }
                    _items.push(newitem);
                }

                this.form.VoucherNo.setSelect2Items(_items);
                //this.form.VoucherNo.items = items;
                //this.form.VoucherNo.setLookupItemArray(items);



                //this.form.VoucherNo.values = [];
            })
            this.form.AllVouchers.changeSelect2(e => {
                if (this.form.AllVouchers.value) {
                    q.showAndDisableField(this.form.VoucherNo);
                    var _vouchernos = this.form.VoucherNo.items;

                    var x = _vouchernos.map(_vouchernos => _vouchernos.text);
                    this.vouchernos = _vouchernos.map(_vouchernos => _vouchernos.text);

                }
                else
                    q.showAndEnableField(this.form.VoucherNo);
            });
        }


        protected getDialogTitle(): string {
            return "Filters";
        }



        onDialogOpen() {
            super.onDialogOpen();
            let vouchers: OMS.VoucherMasterRow[];
            OMS.VoucherMasterService.GetVouchersForTransactions({}, response => {
                if (response.Entities != null && response.Entities.length > 0) {
                    vouchers = response.Entities;
                    var _items = [];
                    for (var i = 0; i < vouchers.length; i++) {
                        var newitem: Serenity.Select2Item = {
                            id: vouchers[i].VoucherTypeId.toString(),
                            text: vouchers[i].VoucherTypeName,
                            source: vouchers[i]
                        }
                        _items.push(newitem);
                    }

                    this.form.VoucherTypeId.setSelect2Items(_items);
                }
            }, { async: false })

            if (this.filterformfor == "Production") {
                q.hideField(this.form.VoucherNo);
                q.hideField(this.form.VoucherTypeId);

                Production.BagHistoryService.BagList({}, response => {
                    var items = response.Entities;
                    var _items = [];

                    for (var i = 0; i < items.length; i++) {
                        var newitem: Serenity.Select2Item = {
                            id: items[i].BagNo,
                            text: items[i].BagNo,
                            source: items[i]
                        }
                        _items.push(newitem);
                    }

                    this.form.BagNo.setSelect2Items(_items);
                }, { async: false })
            } else if (this.filterformfor == "Transaction") {
                q.hideField(this.form.BagNo);
            }
            var itemsonly = this.form.ItemsOnly.value;
            if (itemsonly) {
                q.showField(this.form.Parties);
                q.showField(this.form.AllVouchers);
            }
            else {
                q.hideField(this.form.Parties);
                q.hideField(this.form.AllVouchers);
            }


        }
        protected getDialogButtons() {
            return [
                {
                    text: 'Ok',
                    click: () => {
                        if (!this.validateBeforeSave())
                            return;
                        this.checksuccess = true;
                        if (this.filterformfor == "Transaction") {
                            var itemsonly = this.form.ItemsOnly.value;

                            if (this.form.AllVouchers.value)
                                this.vouchernos = [];
                            var _vouchers = this.form.VoucherNo.selectedItems;
                            var x = this.form.VoucherNo.values;
                            this.vouchernos = _vouchers.map(_vouchers => _vouchers.VoucherNo);
                            var _partyids = this.form.Parties.selectedItems;
                            this.partyids = _partyids.map(_partyids => _partyids.PartyId);

                            this.vouchertypeid = parseInt(this.form.VoucherTypeId.value);
                        }
                        this.dialogClose();

                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }
    }
}